





import {Component, Vue} from 'vue-property-decorator'
import userSession from "@/store/module/UserSession";
import UserApi from "@/module/user/UserApi";
import {Container} from "typescript-ioc";

@Component({})
export default class DashboardView extends Vue {

  private userApi = Container.get(UserApi)

  async handleLogout() {
    if (userSession.isLogged) {
      await userSession.logout()
    }
    this.$redirector.login()
  }
}
